import { JSX } from 'react';
import { Skeleton } from '@mui/material';
import Content from '../content';
import Layout from '.';

/**
 * Component for displaying a loading state for the page layout
 */
const LayoutLoadingState = (): JSX.Element => (
  <Layout>
    <Content>
      <Skeleton variant="text" height={70} width={200} />
      <Skeleton variant="rectangular" height={400} />
    </Content>
  </Layout>
);

export default LayoutLoadingState;
